import echarts from 'echarts/lib/echarts';
const theme = {
    seriesCnt: '7',
    backgroundColor: 'rgba(0,0,0,0)',
    titleColor: '#333333',
    subtitleColor: '#aaaaaa',
    textColorShow: false,
    textColor: '#333',
    markTextColor: '#eeeeee',
    color: [
        '#34C3FF',
        '#A873E6',
        '#13BA9E',
        '#EE5765',
        '#F5A623',
        '#2575FC',
        '#DF6ECD',
        '#8338EC',
        '#E6B980',
        '#51E8FF'
    ],
    borderColor: '#ccc',
    borderWidth: 0,
    visualMapColor: ['#c2edff', '#009de6'],
    legendTextColor: '#8e8e93',
    kColor: '#e01f54',
    kColor0: '#001852',
    kBorderColor: '#f5e8c8',
    kBorderColor0: '#b8d2c7',
    kBorderWidth: 1,
    lineWidth: 2,
    symbolSize: '0',
    symbol: 'circle',
    symbolBorderWidth: '0',
    lineSmooth: false,
    graphLineWidth: 1,
    graphLineColor: '#aaaaaa',
    mapLabelColor: '#000000',
    mapLabelColorE: 'rgb(100,0,0)',
    mapBorderColor: '#444444',
    mapBorderColorE: '#444444',
    mapBorderWidth: 0.5,
    mapBorderWidthE: 1,
    mapAreaColor: '#eeeeee',
    mapAreaColorE: 'rgba(255,215,0,0.8)',
    axes: [
        {
            type: 'all',
            name: '通用坐标轴',
            axisLineShow: true,
            axisLineColor: '#333',
            axisTickShow: true,
            axisTickColor: '#333',
            axisLabelShow: true,
            axisLabelColor: '#333',
            splitLineShow: true,
            splitLineColor: ['#ccc'],
            splitAreaShow: false,
            splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        },
        {
            type: 'category',
            name: '类目坐标轴',
            axisLineShow: true,
            axisLineColor: '#e5e5ea',
            axisTickShow: false,
            axisTickColor: '#333',
            axisLabelShow: true,
            axisLabelColor: '#8e8e93',
            splitLineShow: false,
            splitLineColor: ['#ccc'],
            splitAreaShow: false,
            splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        },
        {
            type: 'value',
            name: '数值坐标轴',
            axisLineShow: false,
            axisLineColor: '#8e8e93',
            axisTickShow: false,
            axisTickColor: '#8e8e93',
            axisLabelShow: true,
            axisLabelColor: '#8e8e93',
            splitLineShow: true,
            splitLineColor: ['#efefef'],
            splitAreaShow: false,
            splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        },
        {
            type: 'log',
            name: '对数坐标轴',
            axisLineShow: true,
            axisLineColor: '#333',
            axisTickShow: true,
            axisTickColor: '#333',
            axisLabelShow: true,
            axisLabelColor: '#333',
            splitLineShow: true,
            splitLineColor: ['#ccc'],
            splitAreaShow: false,
            splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        },
        {
            type: 'time',
            name: '时间坐标轴',
            axisLineShow: true,
            axisLineColor: '#333',
            axisTickShow: true,
            axisTickColor: '#333',
            axisLabelShow: true,
            axisLabelColor: '#333',
            splitLineShow: true,
            splitLineColor: ['#ccc'],
            splitAreaShow: false,
            splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
        }
    ],
    axisSeperateSetting: true,
    toolboxColor: '#999999',
    toolboxEmpasisColor: '#666666',
    tooltipAxisColor: '#cccccc',
    tooltipAxisWidth: 1,
    timelineLineColor: '#293c55',
    timelineLineWidth: 1,
    timelineItemColor: '#293c55',
    timelineItemColorE: '#a9334c',
    timelineCheckColor: '#e43c59',
    timelineCheckBorderColor: 'rgba(194,53,49,0.5)',
    timelineItemBorderWidth: 1,
    timelineControlColor: '#293c55',
    timelineControlBorderColor: '#293c55',
    timelineControlBorderWidth: 0.5,
    timelineLabelColor: '#293c55',
    datazoomBackgroundColor: 'rgba(47,69,84,0)',
    datazoomDataColor: 'rgba(47,69,84,0.3)',
    datazoomFillColor: 'rgba(167,183,204,0.4)',
    datazoomHandleColor: '#a7b7cc',
    datazoomHandleWidth: '100',
    datazoomLabelColor: '#333333'
};
echarts.registerTheme('rsuite_light', theme);
export default theme;
//# sourceMappingURL=rsuite_light.js.map